import React from 'react'
import { Message } from 'semantic-ui-react'

export const UploadingNotification = ({ uploading }: { uploading: Number }) => {
  if (uploading === 0) return null

  return (
    <Message color="blue">
      <Message.Content>Uploading {uploading} files...</Message.Content>
    </Message>
  )
}
